// Activation is done: the green light is off for five seconds and on for five, over and over, in
// real time, with a ring counting each five seconds.
const SLOW = 5, RING = 175.9

function build(el) {
  const part = name => el.querySelector(`.${name}`)

  return {led: part('led'), big: part('big'), glow: part('glow'), ring: part('ring'), seconds: part('seconds'), state: part('state')}
}

function draw({led, big, glow, ring, seconds, state}, t) {
  const on = Math.floor(t / SLOW) % 2 == 1, progress = (t % SLOW) / SLOW

  led.style.fill = on ? '#7dff9b' : '#3c8f57'
  big.style.fill = on ? '#3fae6a' : '#cdd3db'
  glow.setAttribute('opacity', on ? 0.25 : 0)
  ring.setAttribute('stroke-dasharray', `${(RING * progress).toFixed(1)} ${RING}`)
  ring.setAttribute('opacity', on ? 1 : 0.35)
  seconds.setAttribute('opacity', 1)
  seconds.style.fill = on ? '#fff' : '#5b6573'
  if (state.textContent != (on ? 'ON' : 'OFF')) state.textContent = on ? 'ON' : 'OFF'
}

let Hooks = {}

Hooks['Animations.DeviceActivated'] = {
  mounted() {
    const scene = build(this.el)

    // Midway through the light being on, held still.
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return draw(scene, SLOW * 1.5)

    const start = performance.now()
    const frame = now => {
      draw(scene, (now - start) / 1000)
      this.raf = requestAnimationFrame(frame)
    }
    this.raf = requestAnimationFrame(frame)
  },

  destroyed() {
    cancelAnimationFrame(this.raf)
  }
}

export {Hooks}
